import React, { useState } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <AnimatedSection className="bg-barber-dark/50" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-12 text-center" data-id="element-65">
          {t.faq.title}
        </h2>

        <div className="space-y-4" data-id="element-66">
          {t.faq.items.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-barber-black border border-white/5 rounded-lg overflow-hidden" data-id="element-67">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-68">
                  <span className="font-oswald text-xl font-medium" data-id="element-69">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-barber-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={24} data-id="element-70" />
                </button>
                <AnimatePresence data-id="element-71">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-72">
                      <div className="p-6 pt-0 text-gray-400 border-t border-white/5" data-id="element-73">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </AnimatedSection>;
}